import client from '@stores/apollo'
import gql from 'graphql-tag'
import { ScenarioGroupFragment } from '@api/fragments'
import { IScenarioGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface CreateScenarioGroupInput {
  deployAt: string
}

interface IPayload {
  createScenarioGroup: {
    scenarioGroup: IScenarioGroup
  }
}

const mutateHandler = handleFetchResult<IPayload, IScenarioGroup>({
  handler: (data) => data.createScenarioGroup.scenarioGroup,
  name: 'Scenario Group',
})

export default function createGroup(input: CreateScenarioGroupInput): Promise<IScenarioGroup> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation CreateScenarioGroup($input: CreateScenarioGroupInput!) {
    createScenarioGroup(input: $input) {
      scenarioGroup {
        ...ScenarioGroupFragment
      }
    }
  }
  ${ScenarioGroupFragment}
`
